import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corona-virus',
  templateUrl: './corona-virus.component.html',
  styleUrls: ['./corona-virus.component.scss']
})
export class CoronaVirusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
